import { Helpers } from '../../helpers';
import { ICommodity } from '../../interfaces/icommodity';
import { Pipeline } from '../pipeline';

export class CommodityBase {
  CommodityId: number;
  Name: string;
  SortOrder: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Pipelines_Commodity?: Array<Pipeline> | null;

  constructor(item?: ICommodity) {
    if (item) {

      this.CommodityId = item.CommodityId;
      this.Name = item.Name;
      this.SortOrder = item.SortOrder;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Pipelines_Commodity = Helpers.createClassArray(Pipeline, item.Pipelines_Commodity);
    }
  }
}